import { DateTime } from 'luxon';
import { ManagerPackageComponent } from './ManagerPackageComponent';
import { TachoReleaseType } from './TachoReleaseType';

export interface AddTachoInstallerModel {
    file?: File;
    components?: Array<ManagerPackageComponent>;
    componentFiles?: Partial<Record<ManagerPackageComponent, File>>;
    versionMajor: number;
    versionMinor: number;
    versionPatch: number;
    releaseDate: DateTime;
    patchNotes: string;
    releaseType: TachoReleaseType;
    MD5: string;
    SHA256: string;
    size: number;
    isBeta: boolean;
    variant: string;
}

export const defaultAddTachoInstallerModel: AddTachoInstallerModel = {
    file: undefined,
    components: [],
    componentFiles: {},
    patchNotes: '',
    releaseDate: DateTime.fromISO(''),
    versionMajor: 0,
    versionMinor: 0,
    versionPatch: 0,
    releaseType: TachoReleaseType.FullInstaller,
    MD5: '',
    SHA256: '',
    size: 0,
    isBeta: true,
    variant: '',
};
